// 主導覽（側欄、手機分頁列）：每個入口對應一組篩選狀態，仍然以網址參數表示，
// 所以舊連結、分享出去的網址都照常運作，不需要另外的路由。
import type { FilterState } from '../../filters/state.ts';

export type Section = 'upcoming' | 'calendar' | 'released';

export const SECTIONS: readonly Section[] = ['upcoming', 'calendar', 'released'];

/** 目前畫面屬於哪個入口；網址有月份時是月曆；同時勾選未發售與已發售時不屬於任何一個 */
export function activeSection(s: Pick<FilterState, 'status' | 'month'>): Section | null {
  if (s.month) return 'calendar';
  const up = s.status.includes('up');
  const rel = s.status.includes('rel');
  if (up && !rel) return 'upcoming';
  if (rel && !up) return 'released';
  return null;
}

/**
 * 切換入口：保留平台與搜尋等條件，重設頁碼並關閉詳情；已發售改為新到舊。
 * 月曆打開 `thisMonth`（使用者所在時區的本月）。
 */
export function enterSection(s: FilterState, section: Section, thisMonth = ''): FilterState {
  if (section === 'calendar') return { ...s, page: 1, game: null, month: s.month ?? thisMonth };
  const base = { ...s, page: 1, game: null, month: null };
  if (section === 'upcoming') {
    return { ...base, status: ['up'], sort: s.sort === 'date-desc' ? 'date' : s.sort };
  }
  return { ...base, status: ['rel'], sort: s.sort === 'date' ? 'date-desc' : s.sort };
}
